import classNames from "classnames";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import styles from "./styles.module.css";

interface Props {
  routes: Array<{
    title: string;
    path: string;
    content: React.ReactNode;
  }>;
  tabListContainerClassName?: string;
  extraTabListClassName?: string;
  extraTabPanelClassName?: string;
}

export const NavigationTabs: React.FC<React.PropsWithChildren<Props>> = ({
  routes,
  tabListContainerClassName,
  extraTabListClassName,
  extraTabPanelClassName,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const currentTabIndex = routes.findIndex(
    (route) => location.pathname === route.path,
  );

  // TODO: Do we need to handle tabIndex -1?

  return (
    <Tabs
      selectedIndex={currentTabIndex}
      onSelect={(tabIndex) => {
        navigate(routes[tabIndex].path);
      }}
    >
      <div className={tabListContainerClassName}>
        <TabList className={classNames(styles.tabList, extraTabListClassName)}>
          {routes.map((route) => (
            <Tab
              key={route.path}
              className={styles.tabListItem}
              selectedClassName={styles.tabListItemActive}
            >
              {route.title}
            </Tab>
          ))}
        </TabList>
      </div>

      {routes.map((route) => (
        <TabPanel
          key={route.path}
          className={classNames(styles.tabPanel, extraTabPanelClassName)}
          selectedClassName={styles.tabPanelActive}
        >
          {route.content}
        </TabPanel>
      ))}
    </Tabs>
  );
};
